/**
 * @generated SignedSource<<c0754cea70ba5f3efb10b3b435afe09b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePost",
    "kind": "LinkedField",
    "name": "unlikeVibePost",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "likesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "likedByCurrentUser",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "likeButtonUnlikeVibePostMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "likeButtonUnlikeVibePostMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bddf5e7d4b11b1721b2d383a3fe2c31a",
    "id": null,
    "metadata": {},
    "name": "likeButtonUnlikeVibePostMutation",
    "operationKind": "mutation",
    "text": "mutation likeButtonUnlikeVibePostMutation(\n  $request: LikeVibePostRequestInput!\n) {\n  unlikeVibePost(request: $request) {\n    id\n    likesCount\n    likedByCurrentUser\n  }\n}\n"
  }
};
})();

node.hash = "8f579355ea0d7b4fae590c118d3d90b4";

module.exports = node;
